import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8000"
  // baseURL: 'https://bewsprodcuponidoo.becupon.com'
  baseURL: 'https://becupon-ws.qa.idooproject.com'
});
